module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-spec-order"
  }, [_c('div', {
    staticClass: "bc-spec-order__inner"
  }, [_c('a', {
    staticClass: "bc-spec-order__back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("\n      ← " + _vm._s(_vm.$T('观众中心返回')) + "\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "bc-spec-order__title"
  }, [_vm._v(_vm._s(_vm.$T('观众中心确认订单')))]), _vm._v(" "), _c('section', {
    staticClass: "bc-spec-order__card"
  }, [_c('div', {
    staticClass: "bc-spec-order__card-head"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$T('观众中心收货地址')))]), _vm._v(" "), _c('button', {
    staticClass: "bc-spec-order__link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddressForm = !_vm.showAddressForm
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.showAddressForm ? _vm.$T('观众中心取消') : _vm.$T('观众中心新增地址')) + "\n        ")])]), _vm._v(" "), (_vm.showAddressForm) ? _c('div', {
    staticClass: "bc-spec-order__addr-form"
  }, [_c('div', {
    staticClass: "bc-spec-order__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心姓名')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addrForm.name),
      expression: "addrForm.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addrForm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addrForm, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-order__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心手机')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addrForm.phone),
      expression: "addrForm.phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addrForm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addrForm, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-order__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心地区')))]), _vm._v(" "), _c('button', {
    staticClass: "bc-spec-order__area-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.areaShow = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.areaText || _vm.$T('观众中心请选择地区')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-order__field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$T('观众中心详细地址')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addrForm.address),
      expression: "addrForm.address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addrForm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addrForm, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "bc-spec-order__secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveAddress
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$T('观众中心保存地址')) + "\n        ")])]) : (!_vm.addressList.length) ? _c('div', {
    staticClass: "bc-spec-order__hint"
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心请先添加地址')) + "\n      ")]) : _c('div', {
    staticClass: "bc-spec-order__addr-list"
  }, _vm._l((_vm.addressList), function(item) {
    return _c('label', {
      key: item.id,
      staticClass: "bc-spec-order__addr-item",
      class: {
        'is-active': _vm.addressId == item.id
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.addressId),
        expression: "addressId"
      }],
      attrs: {
        "type": "radio",
        "name": "address"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.addressId, item.id)
      },
      on: {
        "change": [function($event) {
          _vm.addressId = item.id
        }, _vm.onAddressChange]
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "bc-spec-order__addr-name"
    }, [_vm._v("\n              " + _vm._s(item.name) + " " + _vm._s(item.tel || item.phone) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "bc-spec-order__addr-detail"
    }, [_vm._v("\n              " + _vm._s(_vm.formatAddress(item)) + "\n            ")])])])
  }), 0)]), _vm._v(" "), (_vm.orderList.length) ? _c('section', {
    staticClass: "bc-spec-order__card"
  }, [_c('h2', {
    staticClass: "bc-spec-order__card-head"
  }, [_vm._v(_vm._s(_vm.$T('观众中心商品信息')))]), _vm._v(" "), _vm._l((_vm.orderList), function(order, oi) {
    return _c('div', {
      key: 'o' + oi,
      staticClass: "bc-spec-order__goods-block"
    }, [_vm._l((order.goods_items), function(goods, gi) {
      return _c('div', {
        key: 'g' + gi,
        staticClass: "bc-spec-order__goods"
      }, [_c('img', {
        attrs: {
          "src": goods.pic_url || goods.pic,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "bc-spec-order__goods-meta"
      }, [_c('div', {
        staticClass: "bc-spec-order__goods-title"
      }, [_vm._v(_vm._s(_vm.goodsTitle(goods)))]), _vm._v(" "), (goods.property_name) ? _c('div', {
        staticClass: "bc-spec-order__goods-sku"
      }, [_vm._v("\n              " + _vm._s(goods.property_name) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "bc-spec-order__goods-row"
      }, [_c('span', [_vm._v(_vm._s(_vm.money(goods.price)))]), _vm._v(" "), _c('span', [_vm._v("× " + _vm._s(goods.count))])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "bc-spec-order__sub"
    }, [_c('span', [_vm._v(_vm._s(_vm.$T('观众中心运费')) + "：" + _vm._s(_vm.money(order.express_price || 0)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$T('观众中心小计')) + "：" + _vm._s(_vm.money(order.pay_price || 0)))])])], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.warnings.length) ? _c('div', {
    staticClass: "bc-spec-order__warn"
  }, _vm._l((_vm.warnings), function(w, i) {
    return _c('p', {
      key: i
    }, [_vm._v(_vm._s(w))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bc-spec-order__footer"
  }, [_c('div', {
    staticClass: "bc-spec-order__total"
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心应付')) + "：\n        "), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.payPrice)))])]), _vm._v(" "), _c('button', {
    staticClass: "bc-spec-order__submit",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.submitOrder
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心提交订单')) + "\n      ")])])]), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '40%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.areaShow),
      callback: function($$v) {
        _vm.areaShow = $$v
      },
      expression: "areaShow"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaListData
    },
    on: {
      "confirm": _vm.areaConfirm,
      "cancel": function($event) {
        _vm.areaShow = false
      }
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('SpectatorOfflinePayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "ids": _vm.orderIds,
      "pay-price": _vm.payPrice
    },
    on: {
      "onPaid": _vm.onOfflinePaid,
      "onClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a5be052","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorOrderConfirm.vue
// module id = 1547
// module chunks = 0